export default __webpack_public_path__ + "static/media/public.3f309d53.svg";